
import React from "react";
import { Button } from "@/components/ui/button";

interface FormSubmitButtonProps {
  loading: boolean;
  children: React.ReactNode;
}

const FormSubmitButton = ({ loading, children }: FormSubmitButtonProps) => {
  return (
    <Button
      type="submit"
      className="w-full bg-anzir hover:bg-anzir/90 text-white mt-6"
      disabled={loading}
    >
      {loading ? (
        <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
      ) : (
        children
      )}
    </Button>
  );
};

export default FormSubmitButton;
